import Urls from '@/lib/urls'
import { MessageTypes } from '@/types'

const TOASTER_NAME = 'toaster'

export const TOASTER = {
  COOKIE_PREFIX: `${TOASTER_NAME}_`,
  COOKIE_VALUE: 'showed',
}

export const NOTIFICATION_KIND = {
  FLASH: 'flash',
  TOASTER: TOASTER_NAME,
  LOCAL: 'local',
}

export const NOTIFICATIONS = {
  PASSWORD_TOKEN_EXPIRED: {
    kind: NOTIFICATION_KIND.LOCAL,
    name: 'Password reset token expired',
    type: MessageTypes.ERROR,
    content:
      'Your request to reset your password has already expired. Please try again.',
    canUserDismiss: true,
  },
  SESSION_EXPIRED: {
    kind: NOTIFICATION_KIND.LOCAL,
    name: 'Token expired',
    type: MessageTypes.ERROR,
    content: `You have been logged out of Jobscan. Please log in again to continue.`,
    canUserDismiss: true,
  },
}

export const VALIDATION_MESSAGES = {
  PASSWORD: {
    MIN: 'Password must be 8 characters or more.',
    REQUIRED: 'Please enter your password.',
    MATCHES: 'Passwords do not match.',
  },
  EMAIL: {
    REQUIRED: 'Please enter your email address.',
    DEFAULT: 'Please enter a valid email address.',
  },
}

export const ERRORS = {
  GENERIC: 'Something went wrong. Please try again later.',
}

export const APP_EVENTS = {
  SESSION_EXPIRED: 'session_expired',
}

export const HEADERS = {
  SPA_VERSION: 'X-SPA-Version',
}

export const LOCAL_STORAGE_KEYS = {
  RESULTS_STEPS_HIDDEN: 'js-results-steps-hidden',
}

export const SKILL_TYPE = {
  SOFT: 'soft',
  HARD: 'hard',
  OTHER: 'other',
}

export const SKILL_ORIGIN = {
  ORIGINAL: 'original',
  PREDICTED: 'predicted',
  VARIATION: 'variation',
}

export const SCAN_DOC_TYPE = {
  RESUME: 'resume',
  COVER_LETTER: 'coverLetter',
}

export const USER = {
  MAX_EXCLUDED_SKILLS: 200,
}

export const COACH_PLANS = {
  PREMIUM_PLUS: 'premiumplus',
  PREMIUM_PLUS_ORG: 'premiumplus_org',
  CAREER_COACH: 'careercoach',
  COACH_LITE: 'price_1NGVBAIrz6geJdm2OxFj5GSI',
}
